import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SafetyArticlePage from "../pages/articles/safety/page";
import ShoppingGuidePage from "../pages/articles/guide/page";
import HowToFindPage from "../pages/articles/finds/page";
import BeginnerArticlePage from "../pages/articles/beginner/page";
import CategoriesArticlePage from "../pages/articles/categories/page";
import CompareArticlePage from "../pages/articles/compare/page";
import SaveMoneyArticlePage from "../pages/articles/save/page";
import ShippingArticlePage from "../pages/articles/shipping/page";
import TrendsArticlePage from "../pages/articles/trends/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/przewodnik-kakobuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/bezpieczenstwo-kakobuy-spreadsheet",
    element: <SafetyArticlePage />,
  },
  {
    path: "/artykul/poradnik-zakupowy-kakobuy",
    element: <ShoppingGuidePage />,
  },
  {
    path: "/artykul/jak-znalezc-najlepsze-produkty-kakobuy",
    element: <HowToFindPage />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-dla-poczatkujacych",
    element: <BeginnerArticlePage />,
  },
  {
    path: "/artykul/najpopularniejsze-kategorie-kakobuy",
    element: <CategoriesArticlePage />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-vs-alternatywy",
    element: <CompareArticlePage />,
  },
  {
    path: "/artykul/jak-oszczedzac-z-kakobuy-spreadsheet",
    element: <SaveMoneyArticlePage />,
  },
  {
    path: "/artykul/kakobuy-shipping-do-polski",
    element: <ShippingArticlePage />,
  },
  {
    path: "/artykul/trendy-kakobuy-2026",
    element: <TrendsArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;